<template>
  <div class="confirm-dialog">
    <modal-title title="Confirm" @close="$emit('cancel')"></modal-title>
    <p>{{ message }}</p>
    <button-bar>
      <button type="button" class="btn btn-primary" @click="yesClicked">
        Yes
      </button>
      <button type="button" class="btn btn-secondary" @click="noClicked">
        No
      </button>
    </button-bar>
  </div>
</template>
<script>
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import ButtonBar from "../buttons/ButtonBar.vue";

export default {
  components: { ButtonBar, ModalTitle },
  props: {
    message: {
      type: String,
      required: true,
    },
    params: {
      required: false,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    yesClicked: function () {
      this.logDebug("User has confirmed the operation.");
      this.$emit("confirm", this.params);
    },
    noClicked: function () {
      this.logDebug("User has cancelled the operation.");
      this.$emit("cancel");
    },
  },
  emits: ["confirm", "cancel"],
};
</script>
